import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { 
    TransactionMenuStore, 
    TransactionMenuConfigDTO, 
    TransactionTypeOption,
    TransactionType 
} from '../types';

const initialState = {
    menus: [] as TransactionMenuConfigDTO[],
    selectedMenu: null as TransactionMenuConfigDTO | null,
    isLoading: false,
    isSubmitting: false,
    error: null as string | null,
    transactionTypes: [] as TransactionTypeOption[],
    filterType: null as TransactionType | null,
    showInactive: false
};

export const useTransactionMenuStore = create<TransactionMenuStore>()(
    devtools(
        (set) => ({
            ...initialState,

            setMenus: (menus) => set({ menus }),
            
            setSelectedMenu: (menu) => set({ selectedMenu: menu }),
            
            setLoading: (loading) => set({ isLoading: loading }),
            
            setSubmitting: (submitting) => set({ isSubmitting: submitting }),
            
            setError: (error) => set({ error }),
            
            setTransactionTypes: (types) => set({ transactionTypes: types }),
            
            setFilterType: (type) => set({ filterType: type }),
            
            setShowInactive: (show) => set({ showInactive: show }),
            
            reset: () => set(initialState)
        }),
        { name: 'transaction-menu-store' }
    )
);
